<template>
    <store-modal
        name="OrphanCreateWithdrawalRequestModalPayout"
        class="create-business-modal create-withdrawal-request-modal"
        @closeModal="handleCancelCreate"
    >
        <template v-if="!_withdrawalStatus" #header>
            <div class="create-business-modal__header">
                <div class="title">
                    {{ title }}
                </div>
            </div>
        </template>
        <template #body>
            <div class="create-business-modal__padding-wrapper" v-if="withdrawalCreated">
                <div class="complete-title">
                    <div v-if="_withdrawalStatus === 'INIT'">
                        <p class="complete__title">{{ $t('create-withdrawal-request-modal.output_created') }}</p>
                        <div class="complete__row">
                            <div class="complete__text-container">
                                <p class="complete__main-text">ID: </p>
                                <p class="complete__main-text">{{ _withdrawalId }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="_withdrawalStatus === 'error'">
                        <svg class="complete__img" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9885_67665)">
                                <rect width="60" height="60" rx="10" fill="#B24D4D"/>
                                <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
                                <path d="M24.9697 24.9697C25.2626 24.6768 25.7374 24.6768 26.0303 24.9697L30 28.9393L33.9697 24.9697C34.2626 24.6768 34.7374 24.6768 35.0303 24.9697C35.3232 25.2626 35.3232 25.7374 35.0303 26.0303L31.0607 30L35.0303 33.9697C35.3232 34.2626 35.3232 34.7374 35.0303 35.0303C34.7374 35.3232 34.2626 35.3232 33.9697 35.0303L30 31.0607L26.0303 35.0303C25.7374 35.3232 25.2626 35.3232 24.9697 35.0303C24.6768 34.7374 24.6768 34.2626 24.9697 33.9697L28.9393 30L24.9697 26.0303C24.6768 25.7374 24.6768 25.2626 24.9697 24.9697Z" fill="white"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_9885_67665">
                                    <rect width="60" height="60" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <p class="complete__main-text">{{ $t('create-withdrawal-request-modal.error') }}</p>
                    </div>
                    <div v-else-if="_withdrawalStatus === 'PROCESSED' || _withdrawalStatus === 'PENDING'">
                        <div class="complete__img">
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9739_70606)">
                                    <rect width="60" height="60" rx="10" fill="#5CA450"/>
                                    <path d="M36.3105 23.5605C36.9329 22.9382 37.942 22.9382 38.5644 23.5605C39.1791 24.1753 39.1867 25.1674 38.587 25.7914L30.1036 36.3957C30.0913 36.411 30.0782 36.4256 30.0644 36.4395C29.442 37.0619 28.4329 37.0619 27.8105 36.4395L22.1868 30.8158C21.5644 30.1934 21.5644 29.1842 22.1868 28.5618C22.8092 27.9395 23.8183 27.9395 24.4407 28.5618L28.8894 33.0106L36.2682 23.6082C36.2813 23.5915 36.2954 23.5756 36.3105 23.5605Z" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_9739_70606">
                                        <rect width="60" height="60" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p class="complete__title">
                            {{ $t('create-withdrawal-request-modal.the_withdrawal_is_completed') }}
                        </p>
                        <p class="complete__main-text">
                            {{ $t('orphan.success-withdrawal') }}
                        </p>
                    </div>
                    <div v-else-if="_withdrawalStatus === 'rejected'">
                        <p class="complete__title">{{ $t('create-withdrawal-request-modal.withdrawal_rejected') }}</p>
                    </div>
                </div>


            </div>
            <new-spinner
                v-else-if="withdrawalCreating"
            />
            <div class="create-business-modal__padding-wrapper" v-if="!withdrawalCreated">

                <selected-address-orphan-withdrawal :label="''" :amount="payload.amount ? prettyAmountWithHideZeros(payload.amount) : 0" :currency="orphanCurrency" :networks="orphanNetwork"/>
                <!--            если выбран адрес, то показываем эти блоки-->
                <template>
                    <div class="create-withdrawal-request-modal__select-address">
                        <base-input
                            v-model.trim="address"
                            :status="(address && !addressValid) || depositWithdrawalAddressesMatch ? 'error' : ''"
                            :placeholder="enter_address"
                            :label="$t('create-withdrawal-request-modal.receiving_address')" />

                        <div class="create-withdrawal-request-modal__address-book">
                            <address-book-select
                              v-model="value"
                              :list="filteredAddressesList"
                              with-search
                              @input="handleSelectAddressFromBook"
                            />
                        </div>

                    </div>
                    <p v-if="(address && !addressValid)" class=" create-withdrawal-request-modal__title-special">
                        {{ $t('create-withdrawal-request-modal.invalid_address') }}
                    </p>

                    <template v-if="hasTag">
                      <div class="create-withdrawal-request-modal__tag">
                        <div class="tag-checkbox">
                          <base-checkbox
                              v-model="skipTagValidation"
                              :label="$t('create-withdrawal-request-modal.without_tag')"
                          />
                        </div>
                        <base-input
                            v-model.trim="tag"
                            :error="!!tag && !tagValid ? $t('create-withdrawal-request-modal.wrong_tag') : ''"
                            :placeholder="enter_tag"
                            :label="$t('create-withdrawal-request-modal.tag')"
                            :disabled="skipTagValidation"
                            error-position-bottom
                        />
                        <div class="attention-info">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.54179 7.17433C5.48737 3.72478 6.46015 2 8.00065 2C9.54115 2 10.5139 3.72477 12.4595 7.17432L12.7019 7.60418C14.3187 10.4707 15.1271 11.904 14.3965 12.952C13.6659 14 11.8583 14 8.24309 14H7.75821C4.14302 14 2.33543 14 1.60482 12.952C0.874213 11.904 1.68259 10.4707 3.29935 7.60418L3.54179 7.17433ZM8.00065 4.83333C8.27679 4.83333 8.50065 5.05719 8.50065 5.33333V8.66667C8.50065 8.94281 8.27679 9.16667 8.00065 9.16667C7.72451 9.16667 7.50065 8.94281 7.50065 8.66667V5.33333C7.50065 5.05719 7.72451 4.83333 8.00065 4.83333ZM8.00065 11.3333C8.36884 11.3333 8.66732 11.0349 8.66732 10.6667C8.66732 10.2985 8.36884 10 8.00065 10C7.63246 10 7.33398 10.2985 7.33398 10.6667C7.33398 11.0349 7.63246 11.3333 8.00065 11.3333Z" fill="#FF7A21"/>
                          </svg>
                          <span class="text">
                                  {{ $t('create-withdrawal-request-modal.tag_warning') }}
                                </span>
                        </div>
                      </div>
                    </template>

                    <div class="create-withdrawal-request-modal__wrapper-comment">
                        <base-textarea
                            v-model="description"
                            :placeholder="$t('address_book.add_modal_placeholder')"
                            :label="$t('address_book.add_modal_comment')"
                            :max-length="255"
                            size="large"
                            resize="none"
                        />
                    </div>

                    <new-spinner class="payout-modal-transfer__info-container" v-if="isDebouncing || _feePending"/>
                    <div
                        v-if="address && !isDebouncing && !_feePending"
                        class="info-container"
                        :class="{ 'disabled': feeAvailableSeconds < 0 }"
                    >
                        <div class="info-container__row">
                            <div class="first-line">
                                <div class="label">
                                    {{ $t('payout-modal-transfer.advance_balance') }}
                                </div>
                                <div class="value">
                    <span
                        :class="{danger: !balanceValid}">{{
                            accountBalance
                        }} {{ accountCurrencyId | getCurrencyTicker }}
                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="info-container__row">
                            <div class="first-line">
                                <div class="label">
                                    {{ $t('payout-modal-transfer.service-commission-amount') }}
                                </div>
                                <div class="value">
                                    {{ tariffFeeUSD }} {{ accountCurrencyId | getCurrencyTicker }}
                                </div>
                            </div>
                            <div class="second-line">
                                <div class="label">
                                    {{ $t('payout-modal-transfer.commission-source') }}
                                </div>
                                <div class="value">
                                    {{ $t('payout-modal-transfer.advance_balance') }}
                                </div>
                            </div>
                        </div>
                        <div class="info-container__row">
                            <div class="first-line">
                                <div class="label">
                                    {{ $t('payout-modal-transfer.blockchain-commission-amount') }}
                                </div>
                                <div class="value">
                                    {{ blockChainCommission }}
                                    <template v-if="_feeSource === 'ADVANCE'">
                                        {{ accountCurrencyId | getCurrencyTicker }}
                                    </template>
                                    <template v-else>
                                        {{ balanceCurrencyId | getCurrencyTicker }}
                                        ({{ networkFeeUSD }} {{ accountCurrencyId | getCurrencyTicker }})
                                    </template>
                                </div>
                            </div>
                            <div class="second-line">
                                <div class="label">
                                    {{ $t('payout-modal-transfer.commission-source') }}
                                </div>
                                <div class="value">
                                    {{ feeSourceTitle }}
                                </div>
                            </div>
                        </div>
                        <div class="info-container__row">
                            <div class="first-line">
                                <div class="label">
                                    <b> {{ $t('payout-modal-transfer.receive') }} </b>
                                </div>
                                <div class="value">
                                    <b> {{ amountToReceive | separatePeriods }}
                                        {{ balanceCurrencyId | getCurrencyTicker }} </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>

        <template v-if="!withdrawalCreating" #footer>
            <template v-if="!withdrawalCreated">
                <div v-if="feeAvailableSeconds !== -1"
                     class="create-withdrawal-request-modal__btn">
                    <base-button
                            type="primary"
                            :disabled="actionButtonDisabled"
                            :label="actionButtonTitle"
                            @click="createWithdrawal"
                    />
                </div>
                <div class="create-withdrawal-request-modal__btn"
                     v-else
                >
                    <base-button
                        type="secondary"
                            :label="$t('create-withdrawal-request-modal.update')"
                            @click="fetchFee"
                    >
                        <template #prepend>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.2638 7.74892C1.2638 11.5139 3.94057 14.0792 6.94724 14.6098C7.02903 14.6242 7.10722 14.655 7.17736 14.7002C7.2475 14.7455 7.3082 14.8044 7.35601 14.8736C7.40382 14.9428 7.4378 15.021 7.456 15.1035C7.4742 15.1861 7.47627 15.2716 7.4621 15.355C7.44792 15.4384 7.41778 15.5181 7.37338 15.5897C7.32899 15.6612 7.27121 15.7231 7.20336 15.7718C7.1355 15.8206 7.05889 15.8552 6.9779 15.8738C6.89692 15.8924 6.81314 15.8945 6.73135 15.88C3.20073 15.2566 0 12.2214 0 7.74892C0 5.84787 0.847786 4.35374 1.83748 3.21831C2.547 2.40445 3.3584 1.74273 4.01092 1.23686H2.02668C1.86585 1.23686 1.7116 1.1717 1.59787 1.05572C1.48415 0.939747 1.42025 0.782447 1.42025 0.618429C1.42025 0.454412 1.48415 0.297112 1.59787 0.181134C1.7116 0.0651559 1.86585 0 2.02668 0H5.66525C5.82609 0 5.98033 0.0651559 6.09406 0.181134C6.20779 0.297112 6.27168 0.454412 6.27168 0.618429V4.329C6.27168 4.49302 6.20779 4.65032 6.09406 4.7663C5.98033 4.88228 5.82609 4.94743 5.66525 4.94743C5.50442 4.94743 5.35017 4.88228 5.23644 4.7663C5.12271 4.65032 5.05882 4.49302 5.05882 4.329V2.04576L5.05761 2.04824C4.36386 2.58009 3.51728 3.23191 2.7835 4.07421C1.91631 5.06865 1.2638 6.27211 1.2638 7.74892ZM14.7362 8.25108C14.7362 4.52566 12.1164 1.9765 9.14857 1.40754C9.06586 1.39323 8.98676 1.36226 8.9159 1.31645C8.84505 1.27063 8.78385 1.21088 8.73587 1.14069C8.6879 1.07049 8.65411 0.991258 8.63649 0.907606C8.61886 0.823955 8.61774 0.737561 8.63321 0.653466C8.64867 0.56937 8.6804 0.489257 8.72654 0.417799C8.77269 0.346342 8.83232 0.284971 8.90198 0.237268C8.97163 0.189565 9.0499 0.156484 9.13222 0.139956C9.21454 0.123428 9.29926 0.123784 9.38144 0.141002C12.8672 0.808905 16 3.82684 16 8.25108C16 10.1521 15.1522 11.645 14.1625 12.7817C13.453 13.5955 12.6416 14.2573 11.9891 14.7631H13.9733C14.1342 14.7631 14.2884 14.8283 14.4021 14.9443C14.5159 15.0603 14.5797 15.2176 14.5797 15.3816C14.5797 15.5456 14.5159 15.7029 14.4021 15.8189C14.2884 15.9348 14.1342 16 13.9733 16H10.3347C10.1739 16 10.0197 15.9348 9.90594 15.8189C9.79221 15.7029 9.72832 15.5456 9.72832 15.3816V11.671C9.72832 11.507 9.79221 11.3497 9.90594 11.2337C10.0197 11.1177 10.1739 11.0526 10.3347 11.0526C10.4956 11.0526 10.6498 11.1177 10.7636 11.2337C10.8773 11.3497 10.9412 11.507 10.9412 11.671V13.953H10.9436C11.6361 13.4187 12.4839 12.7681 13.2165 11.9246C14.0837 10.9314 14.7362 9.72913 14.7362 8.25108Z" fill="#6750A4"/>
                            </svg>
                        </template>
                    </base-button>
                </div>
            </template>
            <template v-else>
                <base-button
                        type="primary"
                        :label="$t('create-withdrawal-request-modal.close')"
                        @click="handleCancelCreate"
                />
            </template>
        </template>
    </store-modal>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';

    import AtSelect from 'at-ui/src/components/select';
    import AtOption from 'at-ui/src/components/option';
    import AtModal from 'at-ui/src/components/modal';
    import CurrencyImg from "/public/components/elements/CurrencyImg";
    import AtInput from 'at-ui/src/components/input';
    import AtRadioGroup from 'at-ui/src/components/radio-group';
    import AtRadio from 'at-ui/src/components/radio';
    import LoadingSpinner from "/public/components/elements/LoadingSpinner";
    import AtButton from 'at-ui/src/components/button';
    import WithdrawalAddress from "../../modals/requests/components/WithdrawalAddress";
    import AtAlert from 'at-ui/src/components/alert';
    import BaseModal from "../BaseModal";
    import CopyString from "/public/components/elements/CopyString";
    import moment from "moment";
    import bchaddr from 'bchaddrjs';

    import { getNetworkName, prettyAmountWithHideZeros } from '/public/filters';
    import BigNumber from "bignumber.js";
    import {FEE_TOKEN_SOURCE} from "../../../../common/constants/fee-token-source";
    import _ from "lodash";
    import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
    import BusinessWalletNetworkSelect
        from "@/public/components/elements/business-walet/Select/businessWalletNetworkSelect.vue";
    import BaseInput from "@/public/components/common/uiKit/input/base/index.vue";
    import BaseTextarea from "@/public/components/common/uiKit/textarea/index.vue";
    import AddressBookSelect from "@/public/components/elements/business-walet/addressBookSelect/addressBookSelect.vue";
    import SelectedAddressOrphanWithdrawal from "@/public/components/modals/orphan/SelectedAddressOrphanWithdrawal.vue";
    import cloneDeep from "lodash/cloneDeep";

    export default {
    name: 'OrphanCreateWithdrawalRequestModalPayout',
    components: {
        SelectedAddressOrphanWithdrawal,
        AddressBookSelect,
        BaseTextarea,
        BaseInput,
        BusinessWalletNetworkSelect,
        BaseButton,
        BaseModal,
        AtSelect,
        AtOption,
        AtModal,
        CurrencyImg,
        AtInput,
        AtRadioGroup,
        AtRadio,
        LoadingSpinner,
        AtButton,
        WithdrawalAddress,
        AtAlert,
        CopyString,
        NewSpinner: () => import (/* webpackChunkName: "Spinner" */ "/public/components/common/uiKit/spinner/index.vue"),
        Search: () => import(/* webpackChunkName: "/public/components/elements/advanced-balances/NetworkAndCurrenciesList/Search" */ '/public/components/elements/business-walet/Select/Search.vue'),
        BaseMaxInput: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/input" */ '/public/components/elements/advance-balances/input'),
        StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
        BaseCheckbox:  () => import(/* webpackChunkName: "/public/components/common/uiKit/Checkbox/index.vue" */ '/public/components/common/uiKit/Checkbox/index.vue')
    },
    data() {
        return {
            accountId: '',
            addressModel: {},
            networkId: '',
            value: '',
            temporaryValue: {},
            search: '123123',
            address: '',
            tag: '',
            amount: '',
            isDebouncing: null,
            time: new Date().toJSON(),
            timerId: 0,
            description: '',
            addressBookId: '',
            transactionHash: '',
            currentModal: 'BusinessCreateWithdrawalRequestModal',
            skipTagValidation: false
        };
    },
    computed: {
        ...mapState('app', {
            currencies: state => state.currencies,
            // addressWithdrawal: state => state.modal.payload.orphan.inTransaction.addressId,
            orphan: state => state.modal.payload,
            networks: state => state.networks
        }),
        ...mapState('accounts', [
            'accounts',
        ]),
        ...mapState('balances', {
            balancesGroupedBusiness: (state) => state.balancesGroupedBusiness.currencyGroups,
        }),
        ...mapGetters('balances', [
            'balances',
        ]),
        ...mapGetters('app', [
            'isOpenModal',
        ]),
        ...mapState('withdrawalRequestModal', [
            'withdrawal',
        ]),
        ...mapState('addressBook', {
            listAddress: state => state.listCurrenciesAddress,
        }),
        ...mapState('balances', {
            balancesGroupedBusiness: (state) => state.balancesGroupedBusiness.currencyGroups,
        }),
        ...mapState('withdrawalRequestModal', {
            _feePending: state => state.fee.pending,
            _feeComplete: state => state.fee.complete,
            _feeCode: state => state.fee.code,
            _feeAmount: state => state.fee.amount,
            _feeAmountToReceive: state => state.fee.amountToReceive,

            _tariffFee: state => state.fee.tariffFee,
            _tariffFeeUSD: state => state.fee.tariffFeeUSD,
            _networkFee: state => state.fee.networkFee,
            _networkFeeUSD: state => state.fee.networkFeeUSD,

            _feeUSD: state => state.fee.usdAmount,
            _feeUntil: state => state.fee.until,
            _feeCurrency: state => state.fee.currency,
            _feeToken: state => state.fee.token,
            _feeSource: state => state.fee.source,

            _withdrawalPending: state => state.withdrawal.pending,
            _withdrawalComplete: state => state.withdrawal.complete,
            _withdrawalRequestId: state => state.withdrawalRequestId,
            _withdrawalError: state => state.withdrawal.error,
            _withdrawalId: state => state.withdrawal.id,
            _withdrawalStatus: state => state.withdrawal.status,
            _withdrawalTX: state => state.withdrawal.tx,
        }),
        filteredAddressesList () {
            return this.listAddress.filter(({networks}) => networks.some(item => item === this.balanceNetworkId))
        },
        addressWithdrawal () {
            if (!this.payload.inTransaction) {
                return ''
            }
          return this.payload.inTransaction.addressId
        },
        payload () {
            if (!this.orphan) {
                return {}
            }
            return this.orphan.orphan
        },
        withdrawalCreated() {
            return !this._withdrawalPending && this._withdrawalComplete && this._withdrawalRequestId;
        },
        withdrawalCreating() {
            return this._withdrawalPending;
        },

        fetchingFee() {
            return this._feePending;
        },
        fetchedSuccessFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode === 0;
        },
        fetchedFailFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode !== 0;
        },

        feeSourceTitle() {
            if (this._feeSource === 'ADVANCE') {
                return this.$t('create-withdrawal-request-modal.advance_balance');
            } else if (this._feeSource === 'ADDRESS') {
                return this.$t('create-withdrawal-request-modal.withdrawal_amount');
            }

            return '';
        },
        tariffFee() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._tariffFee);
        },
        tariffFeeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._tariffFeeUSD);
        },
        blockChainCommission () {
            if (this._feeSource === 'ADVANCE') {
                return this.networkFeeUSD;
            } else if (this._feeSource === 'ADDRESS') {
                return this.networkFee;
            }
        },
        networkFee() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._networkFee);
        },
        networkFeeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._networkFeeUSD);
        },

        feeAmount() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._feeAmount);
        },
        feeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return this._feeUSD;
        },
        feeCurrency() {
            if (!this.fetchedSuccessFee) {
                return '';
            }

            return this._feeCurrency;
        },
        feeAvailableSeconds() {
            const now = moment(this.time);
            const until = moment(this._feeUntil);

            const delta = until.diff(now, 'seconds');

            if (delta > 0) {
                return delta;
            }

            if (delta <= -1) {
                return -1;
            }

            return 0;
        },

        account() {
            return this.accounts.find(a => a.accountId === this.accountId);
        },
        accountCurrency() {
            return this.currencies.find(c => c.id === this.account?.currencyId);
        },
        accountBalance() {
            return this.account?.balance || '0';
        },

        accountCurrencyId() {
            return this.accountCurrency?.id;
        },

        addressesList() {
            return []
        },

        orphanCurrency() {
            return this.currencies.find(({id}) => id === this.payload.currencyId);
        },
        balanceAmount() {
            return Number(this.balance?.balance || '0');
        },
        orphanNetwork() {
            return this.networks.find(({id}) => id === this.payload.networkId);
        },
        balanceCurrency({ balanceCurrencyId }) {
          return this.currencies.find(c => c.id === balanceCurrencyId);
        },
        balanceCurrencyId() {
            return this.payload.currencyId;
        },
        balanceNetworkId() {
            return this.payload.networkId;
        },

        balanceNetwork({ balanceNetworkId }) {
          return this.balanceCurrency?.networks.find(n => n.id === balanceNetworkId);
        },

        hasTag() {
          return this.balanceNetwork?.tagRegex;
        },

        balanceValid() {
            if (this._feeSource === FEE_TOKEN_SOURCE.ADVANCED_BALANCE) {
                return new BigNumber(this.accountBalance).gte(this.feeAmount);
            }

            return true;
        },
        addressValid() {
            const currency = this.currencies.find(({ id }) => id === this.payload.currencyId)
            const network = this.networks.find(({ id }) => id === this.payload.networkId)
            if (this.addressWithdrawal) {
                if (currency?.currency === "BCH") {
                    return bchaddr.isValidAddress(this.address);
                }
            }

            return network && network.addressRegex && new RegExp(network.addressRegex).test(this.address);
        },
        tagValid({ skipTagValidation }) {
          if (!this.hasTag || skipTagValidation) {
            return true
          }

          return !!this.tag && this.balanceNetwork && this.balanceNetwork.tagRegex && new RegExp(this.balanceNetwork.tagRegex).test(this.tag);
        },
        amountToReceive() {
            if (this._feeAmountToReceive !== null) {
                return this._feeAmountToReceive
            }
            if (this._feeSource === FEE_TOKEN_SOURCE.WALLET) {
                const amount = new BigNumber(this.amount || '0')
                    .minus(this.networkFee)
                    .dp(8, BigNumber.ROUND_HALF_UP);

                if (amount.lte(0)) {
                    return 0;
                }

                return amount.toNumber();
            }

            return new BigNumber(this.amount || '0')
                .dp(8, BigNumber.ROUND_HALF_UP)
                .toNumber();
        },

        actionButtonDisabled() {
            if (!this.tagValid) {
              return true;
            }

            return !this.addressValid;
        },
        actionButtonTitle() {
            let title = this.$t('create-withdrawal-request-modal.send');

            if (this.feeAvailableSeconds !== -1 && this.amount !== '' && !this.isDebouncing && this.address.length) {
                title += ` (${this.feeAvailableSeconds}s)`;
            }

            return title;
        },

        isOpen() {
            const {
                $options: {name},
                isOpenModal,
            } = this;

            return isOpenModal(name);
        },
        title() {
            return this.$t(this.isSuccess ? 'create-withdrawal-request-modal.application_created' : 'create-withdrawal-request-modal.creating_application');
        },
        hasErrors() {
            return Boolean(this.errors.length);
        },
        creating_an_application() {
            return this.$t('create-withdrawal-request-modal.creating_an_application');
        },
        select_address() {
            return this.$t('create-withdrawal-request-modal.select_address');
        },
        enter_address() {
            return this.$t('create-withdrawal-request-modal.enter_address');
        },
        enter_tag() {
            return this.$t('create-withdrawal-request-modal.enter_tag');
        },
        enter_amount() {
            return this.$t('create-withdrawal-request-modal.enter_amount');
        },
        showMinWithdrawalTip() {
            return this.minWithdrawal !== 0;
        },
        getCurrencyImageForSelect() {
           return this.payload.currencyId;
        },
        depositWithdrawalAddressesMatch() {
            return true;
        },

    },
    methods: {
        ...mapActions('app', [
            'closeModal',
            'openModal',
        ]),
        ...mapActions('accounts', [
            'getAllNetworks',
        ]),
        ...mapActions('balances', [
            // 'getAllBalances',
            // 'fetchBalances',
            'getAccountBalancesGrouped',
            'getPrice',
        ]),
        ...mapActions('addressBook', [
            'getAddressBook',
            'networkAddressBook',
            'ChangeAddressBook',
        ]),
        ...mapActions('withdrawalRequests', {
            refreshRequests: 'fetchWithdrawalRequests',
            createWithdrawalRequest: 'createWithdrawalRequest',
            fetchNetworkFee: 'fetchNetworkFee',
            requestWithdrawal: 'requestWithdrawal',
        }),
        ...mapActions('withdrawalRequestModal', {
            clearFee: 'clearFee',
            clearWithdrawal: 'clearWithdrawal',

            _fetchFee: 'fetchOrphanFee',
            _createWithdrawal: 'createOrphanWithdrawal',
        }),
        prettyAmountWithHideZeros,
        fetchFee() {
            if (!(this.address && this.accountId)) {
                return;
            }
            this.clearFee();
            this._fetchFee({
                advancedBalanceId: this.accountId,
                orphanDepositId: this.payload.id
            });
        },
        mobileText(text) {
            if (window.innerWidth <= 576 && text !== null) {
                return text.length > 6 ? `${text.substr(0, 6)}...` : text;
            }
            return text;
        },

        changeAddress(item) {
            const {openModal} = this;
            openModal({
                name: 'ChangeAddressBook',
                payload: {
                    currentId: item.id,
                    currentIdNetwork: item.networks[0],
                    address: item.address,
                    comment: item.comment,
                    noteText: item.alias,
                },
            });
        },

        handleSelectAddressFromBook(value) {
          if (value) {
            this.address = this.listAddress.find(item => item.id === value.id).address;
            this.temporaryValue = cloneDeep(value)
          }
        },

        maxAmount() {
            this.amount = this.balance.balance;
        },
        clearAllData() {
            this.accountId = '';
            this.addressModel = {};
            this.address = '';
            this.tag = '';
            this.amount = '';
            this.description = '';

            this.clearFee();
            this.clearWithdrawal();
        },
        handleCancelCreate() {
            const {
                clearAllData,
                closeModal,
            } = this;
            closeModal();
            if (this.withdrawalCreated && this.accountId.length) this.getAccountBalancesGrouped({accountId: this.accountId});

            setTimeout(() => {
                this.clearAllData();
                this.clearFee()
                this.clearWithdrawal()
            }, 500);
        },

        // selectCurrency(balanceId) {
        //     if (!balanceId) {
        //         return false;
        //     }
        //
        //     this.currencyBalance = this.accountBalances.find(balance => balance.id === balanceId);
        //
        //     this.networkFee = this.currencies.find(el => el.id === this.currencyBalance.currencyId).networks.find(network => network.id === this.currencyBalance.networkId).networkFee;
        //
        //     this.getPrice({
        //         from: `${getCurrencyTicker(this.account.currencyId)}`,
        //         to: `${getCurrencyTicker(this.currencyBalance.currencyId)}`,
        //     });
        //
        //
        // },

        startTimer() {
            if (this.timerId) {
                return;
            }

            this.timerId = setInterval(() => {
                this.time = new Date().toJSON();
            }, 1000);
        },
        stopTimer() {
            clearInterval(this.timerId);

            this.timerId = 0;
        },

        createWithdrawal() {
            if (this._withdrawalPending) {
                return;
            }

            if (this.actionButtonDisabled) {
                return;
            }
            const payload = {
                advancedBalanceId: this.accountId,
                address: this.address,
                comment: this.description,
                token: this._feeToken,
                orphan: this.payload,
                tag: this.tag || undefined
            };
            this.clearWithdrawal()
            this.openModal({
              name: 'TwoFaConfirmation',
              payload
            });
            // this._createWithdrawal(payload);
        },


        addAddress() {
            const {openModal} = this;

            openModal({
                name: 'NewAddressModal',
            });
        },
    },
    watch: {
        address(v) {
          this.fetchFee();

          if (v !== this.temporaryValue.address) {
            this.value = {}
          } else {
            this.value = cloneDeep(this.temporaryValue)
          }
        },
        addressWithdrawal: {
        deep: true,
        handler (n, o) {
          this.value = '';
          this.address = '';
          let networkTicker;
          const network = this.payload.networkId;

          if (network) networkTicker = getNetworkName(network);

          this.getAddressBook({
            route: this.$route,
            router: this.$router,
            page: 1,
            showUrlFilters: false,
            networks: [`${networkTicker}`],
          });

          if (!n) {
            return;
          }

          if (n === o) {
            return;
          }
          if (this.isDebouncing === null) {
            this.isDebouncing = false;
          }
          this.fetchFee();
        }
      },
        accounts() {
            if (this.accounts.length) {
                this.accountId = this.accounts[0].accountId;
            }
        },
        isOpen(status) {
        if (!status) {
          this.clearAllData();
          this.stopTimer();

          return;
        }
        this.startTimer();

        if (this.accounts.length) {
          this.accountId = this.accounts[0].accountId;
        }
        this.$nextTick(() => {
          const network = this.payload.networkId;
          let networkTicker;
          if (network) networkTicker = getNetworkName(network);

          this.getAddressBook({
            route: this.$route,
            router: this.$router,
            page: 1,
            showUrlFilters: false,
            networks: [`${networkTicker}`],
          });
        });

        this.networkAddressBook();
      },
        skipTagValidation(v) {
        if (!!v) {
          this.tag = undefined
        }
      },
        withdrawal: {
          deep: true,
          handler (val) {
            this.transactionHash = val.tx
          }
        },
        withdrawalCreated(n, o) {
          if (!(typeof n !== "undefined" && typeof o !== "undefined")) {
            return;
          }

          if (n === o) {
            return;
          }

          if (!n) {
            return;
          }
          this.$emit('update')
          // this.refreshRequests({
          //     route: this.$route,
          //     router: this.$router,
          // });
        },
        _withdrawalError(message) {
            if (!message) {
                return;
            }

            this.$Message.error(this.$t(message));

            // this.clearWithdrawal();
        },

    },
};
</script>
<style lang="scss" scoped>
.main-modal-wrapper .main-modal-body {
    max-height: 450px;
    overflow: auto;
}
.info-container {
    margin-top: 30px;
    //border-bottom: 1px dashed var(--border-color);

    &.disabled {
        border-bottom: 1px dashed var(--new-front-border-color-disabled);

        .info-container__row {
            border-top: 1px dashed var(--new-front-border-color-disabled);
            &:first-child {
                border-top: none;
            }
            .first-line {
                color: var(--new-front-primary-font-color-disabled);
                .value {
                    .grey {
                        color: var(--new-front-primary-font-color-disabled);
                    }
                }
            }
            .second-line {
                color: var(--new-front-primary-font-color-disabled);
            }
        }
    }

    &__row {
        width: 100%;

        font-size: $h4;

        border-top: 1px dashed var(--new-front-input-border);
        &:first-child {
            border-top: none;
        }
        padding: 10px 0;

        .first-line {
            display: flex;
            align-items: center;

            color: var(--new-front-primary-font-color);

            padding: 5px 0;

            .label {
                width: 100%;
                text-align: left;
            }
            .value {
                text-align: right;
                white-space: nowrap;

                .grey {
                    color: var(--new-front-secondary-font-color);
                }
            }
        }
        .second-line {
            display: flex;
            align-items: center;

            color: var(--new-front-secondary-font-color);

            padding: 5px 0;

            .label {
                width: 100%;
                text-align: left;
            }
            .value {
                text-align: right;
                white-space: nowrap;
            }
        }
    }
}
.create-business-modal {
    font-family: $Gilroy;
    &__padding-wrapper {
        padding: 0 $p30;
    }
    &__header {
        text-align: center;

        .title {
            font-size: $h1;
            font-weight: 500;
            color: var(--new-front-primary-font-color);
        }
        .subtitle {
            font-size: $h4;
            color: var(--secondary-font-color);
        }
    }
    &__body {
        padding: 0 0 $p30 0;
    }
    &__footer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
    }
    &::v-deep {
        .list {
            max-height: 290px !important;
        }
    }
}
.create-withdrawal-request-modal ::v-deep .at-modal__header p, .at-modal__header .at-modal__title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
}

.create-withdrawal-request-modal ::v-deep .at-modal__header {
    min-height: 107px;
    display: flex;
    align-items: center;
    padding-left: 60px;
    border-bottom: 1px solid var(--border-color);
    border-radius: 20px 20px 0 0;
}

.create-withdrawal-request-modal ::v-deep .at-modal {
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    border-radius: 20px;
}

.create-withdrawal-request-modal ::v-deep .at-modal__close {
    font-size: 24px;
    color: #8F949A;
    top: 37px;
    right: 37px;
}

.create-withdrawal-request-modal ::v-deep .at-modal__body {
    padding: 26px 60px 0 60px;
}

::v-deep .at-modal {
    max-width: 764px;
}


.create-withdrawal-request-modal__select-currency ::v-deep .at-select__selection {
    padding-left: 30px;
    border: 1px solid var(--border-color);
    background: transparent;
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    min-height: 46px;
    display: flex;
    align-items: center;
}

.create-withdrawal-request-modal__select-currency_selected ::v-deep .at-select__selection {
    padding-left: 68px;
}

.create-withdrawal-request-modal ::v-deep .at-select__dropdown .at-select__option:hover {
    background: var(--hover-color-select);
}

.create-withdrawal-request-modal ::v-deep .at-select__dropdown .at-select__option {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
}

.create-withdrawal-request-modal ::v-deep .at-select__dropdown {
    background-color: var(--secondary-color);
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select  {
    width: 48px;
    height: 48px;
    margin: 0;
    padding: 0;
    min-width: auto;
}

.create-withdrawal-request-modal__wrapper-comment ::v-deep .at-textarea__original {
    background: var(--secondary-color);
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__selection  {
    width: 48px;
    height: 48px;
    //border-radius: 12px;
    //border: 1px solid #0059F7;
    //background: var(--secondary-color);
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__selected  {
    display: none;
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__arrow  {
    display: none;
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__dropdown {
    max-height: 410px;
    min-width: 450px;
    left: auto !important; /* костыль для позициоирования по левую сторону от кнопки */
    right: 0 !important; /* костыль для позициоирования по левую сторону от кнопки */
    margin-top: 5px;
    background-color: var(--secondary-color);
    //border: 1px solid var(--border-color);
    box-shadow: 0 8px 50px rgba(10, 17, 105, 0.08);
    border-radius: 12px;
    padding: 0;
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__placeholder {
    display: none;
}

.create-withdrawal-request-modal__address-book ::v-deep .at-select__option {
    padding: 25px 30px;
}

@media screen and (max-width: 576px) {
    .create-withdrawal-request-modal__address-book ::v-deep .at-select__dropdown {
        min-width: 300px;
    }

    .create-withdrawal-request-modal__address-book ::v-deep .at-select__option {
        padding: 20px 15px;
    }
}




.create-withdrawal-request-modal ::v-deep .at-select__option--selected {
    background: var(--hover-color-select);
}

.create-withdrawal-request-modal ::v-deep .at-select__placeholder {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
}

.create-withdrawal-request-modal ::v-deep .at-select__selection {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
}

.create-withdrawal-request-modal ::v-deep .at-select__arrow {
    font-size: 24px;
    color: #8F949A;
    margin-top: 0;
    top: calc(50% - 12px);
}

.create-withdrawal-request-modal ::v-deep .at-input__original {
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    min-height: 46px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
    padding-left: 30px;
}

.create-withdrawal-request-modal ::v-deep .at-textarea__original {
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    min-height: 140px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
    padding: 15px;
}

.create-withdrawal-request-modal ::v-deep .at-modal__footer {
    border: none;
    padding-top: 0;
    padding-bottom: 0;
    min-height: 151px;
    padding-right: 60px;
    padding-left: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.create-withdrawal-request-modal ::v-deep .at-btn {
    height: 60px;
    max-width: 311px;
    border-radius: 12px;
}

.create-withdrawal-request-modal__btn ::v-deep .at-btn {
    min-width: 100%;
    height: 60px;
    max-width: 311px;
    border-radius: 12px;
}

.create-withdrawal-request-modal ::v-deep .at-btn--default {
    color: #0059F7;
    border: 1px solid #0059F7;
}

.create-withdrawal-request-modal ::v-deep .at-btn--default:hover {
    color: #0059F7;
    border: 1px solid #0059F7;
}

.create-withdrawal-request-modal ::v-deep .at-btn--default > .at-btn__text {
    color: #0059F7;
}

.create-withdrawal-request-modal ::v-deep .at-input {
    width: 88%;
}

.create-withdrawal-request-modal ::v-deep .at-btn__text {

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    /* identical to box height */

    text-align: center;
}

.at-input--error ::v-deep .at-input__original {
    border-color: red;
}

@media screen and (max-width: 950px) {
    .create-withdrawal-request-modal ::v-deep .at-modal__header {
        padding-left: 30px;
        min-height: 48px;
    }

    .create-withdrawal-request-modal ::v-deep .at-input__original {
        font-size: var(--font-size-text-secondary);
        padding-left: 20px;
    }

    .create-withdrawal-request-modal ::v-deep .at-select__selection {
        font-size: var(--font-size-text-secondary);
    }

    .create-withdrawal-request-modal ::v-deep .at-modal__footer {
        padding-left: 10px;
        padding-right: 10px;
        flex-direction: column-reverse;
    }

    .create-withdrawal-request-modal ::v-deep .at-modal__body {
        padding-left: 10px;
        padding-right: 10px;
    }

    .create-withdrawal-request-modal ::v-deep .at-modal__close {
        font-size: 24px;
        color: #8F949A;
        top: 12px;
        right: 27px;
    }

    .create-withdrawal-request-modal ::v-deep .at-modal__header p, .at-modal__header .at-modal__title {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
    }

    .create-withdrawal-request-modal__select-currency ::v-deep .at-select__selection {
        padding-left: 20px;
    }

    .create-withdrawal-request-modal__select-currency_selected ::v-deep .at-select__selection {
        padding-left: 52px;
    }

    .create-withdrawal-request-modal__select-address ::v-deep .at-input--error {
        border-color: #FF4949;
    }

}

.create-withdrawal-request-modal__address-btn ::v-deep .at-btn {
    max-width: 100%;
}
</style>
<style lang="scss" scoped>

.complete {
    &-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 110px;
    }
  &__title {
    font-family: $Gilroy;
    font-size: $h1;
    font-weight: 500;
    color: var(--new-front-primary-font-color);
    margin-bottom: 20px;
      text-align: center;
  }
    &__img {
        width: 100%;
        display: flex;
        justify-content: center;
        margin:0 0 30px 0;
    }
  &__row {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 20px;
    align-items: center;

  }

  &__text-container {
    display: flex;
      align-items: center;
    justify-content: center;
    width: 100%;
      margin-top: 10px;
  }
    &__link {
        color: #6750A4;
        font-size: 16px;
        margin-left: 5px;
    }
    &__svg {
        margin-left: 5px;
    }
  &__main-text {
    font-family: $Gilroy;
    font-size: $h4;
    color: var(--new-front-secondary-font-color);
      text-align: center;
      line-height: 16px;
  }
}

.currency-img_preview {
  position: absolute;
  z-index: 2;
  top: 11px;
  width: 24px;
  height: 24px;
  left: 30px;
}


.create-withdrawal-request-modal {
  &__select-currency {
    position: relative;
  }

  &__tag {
    position: relative;
    margin-top: 20px;

    .tag-checkbox {
      position: absolute;
      right: 0;
      top: -12px;

      ::v-deep .checkbox-label {
        font-size: $h6;
        color: var(--new-front-input-label-font-color);
      }
    }
    .attention-info {
      display: flex;
      align-items: start;

      padding: 10px;
      font-size: $h6;
      line-height: 19px;
      margin-top: 5px;

      border-radius: 10px;
      background-color: var(--ocp-status-medium-medium-orange-bg);

      svg {
        min-width: 18px;
        min-height: 18px;
        margin-right: 2px;

      }
      .text {
        padding-left: 5px;
        color: var(--new-front-primary-font-color);
      }
    }
  }

  &__btn {
    width: 100%;
  }

  &__info-container {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    gap: 30px;
    padding: 30px;
    border: 1px solid var(--border-color);
    border-radius: 12px;
  }

  .danger {
    color: #fa5d4f;;
  }

  &__row {
    margin-bottom: 16px;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__title {
    font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: var(--new-front-primary-font-color);
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;

    span {
      font-size: 12px;
    }

    &-special {
      font-family: $Gilroy;
      color: var(--new-front-input-font-color-error);
      font-size: $h6;
      line-height: var(--line-height);
    }
  }

  &__title-end {
    font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: $h6;
    line-height: 19px;
    color: var(--new-front-primary-font-color);
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
      span {
          margin: 0 5px;
          color:var(--new-front-secondary-font-color) ;
      }
  }

  &__title1 {
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    font-family: 'Roboto';
    font-style: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-font-color);

    &.disabled {
      color: #E0E0E0;
    }
  }

  &__address-btn {
    width: calc(100% - 60px);
    margin: auto;
    margin-top: 15px;
    margin-bottom: 30px;
    background: #0059F7;
    border-radius: 12px;

    @media screen and (max-width: 576px) {
      margin-top: 20px;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__wrapper-comment {
    //margin-top: -20px;

    @media screen and (max-width: 576px) {
      margin-top: 0;
    }
  }

  &__title2 {
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    font-family: 'Roboto';
    font-style: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-font-color);

    &.disabled {
      color: #E0E0E0;
    }

    @media screen and (max-width: 576px) {
      font-size: 14px;

      span {
        white-space: nowrap;
      }
    }
  }

  &__address-book {
    width: 48px;
    height: 48px;
    margin-left: 20px;
    //border: 1px solid #0059F7;
    //border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: transparent;

    svg {
      position: absolute;
      z-index: 1;
      pointer-events: none;
    }

    & .address-option {
      & .info-block {
        width: 100%;
        display: flex;
        justify-content: space-between;

        & .address {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 23px;
          color: var(--primary-font-color);

          @media screen and (max-width: 576px) {
            font-size: 16px;
          }
        }

        & .info {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 23px;
          color: var(--primary-font-color);
          display: flex;

          @media screen and (max-width: 576px) {
            font-size: 16px;
          }
        }
      }

      & .info-icon {
        width: 24px;
        height: 24px;
        margin-left: 15px;

        @media screen and (max-width: 576px) {
          width: 20px;
          height: 20px;
          margin-left: 17px;
        }
      }
    }
  }

  &__select-address {
      display: flex;
      align-items: end;
      margin-bottom: $p20;
  }

  &__title2-sub {
    color: var(--secondary-font-color);

    &.disabled {
      color: #E0E0E0;
    }
  }

  &__currency {
    display: flex;
    align-items: center;
  }

  &__currency-img {
    margin-left: 8px;
    margin-right: 4px;
    width: 24px;
    height: 24px;
  }

  &__withdrawal-wrapper {
    display: flex;
    justify-content: space-between;
  }

  &__full-width-btn {
    width: 100%;
  }

  &__table-header {
    margin-left: 0;
    margin-right: 0;
    padding: 4px 12px;
    background-color: $gray;
    border: 1px solid $gray2;
  }

  &__add-address {
    margin-top: 12px;
  }

  .address-option {
    display: flex;

    justify-content: flex-start;
    align-items: center;

    .currency-img {
      margin-left: 8px;
      margin-right: 4px;
      width: 20px;
      height: 20px;
    }

    .info-block {
      padding-left: 12px;

      .address {
      }

      .info {
        span {
          color: grey;
        }
      }
    }
  }

  .amount-input {
    display: flex;
    align-items: center;
    align-content: center;
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    width: 100%;
    color: var(--primary-font-color);
    font-size: 12px;
    background-color: var(--secondary-color);
    outline: none;
    min-height: 46px;
    padding-left: 18px;

    &:hover, &:focus, &:active {
      border-color: #79A1EB;
    }

    &.error {
      border-color: #FF4949;
    }

    .input {
      padding: 6px 12px;
      background-color: transparent;
      outline: none;
      border: 0;

      width: calc(100% - 70px);
    }

    .max-button {
      display: block;

      text-align: center;

      width: 70px;

      border-left: 1px solid #79A1EB;
    }
  }
}

@media screen and (max-width: 950px) {
  .currency-img_preview {
    left: 18px;
  }

  .create-withdrawal-request-modal {
    .amount-input {
      padding-left: 8px;
    }

    &__info-container {
      padding: 14px;
      margin-top: 30px;
    }

    &__title1 {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
    }
  }

}
.df-sb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row-reverse;
}
@media (max-width: 575px) {
    .create-business-modal__header {
        .title {
            font-size: 20px;
        }
    }
    .create-business-modal__padding-wrapper {
        padding: 0 20px;
    }
    .create-business-modal__footer {
        display: flex;
        flex-direction: column-reverse;
        grid-gap: 10px;
    }
    .create-business-modal__body {
        padding: 0;
    }

    .business-modal__asset-network,
    .business-modal__asset-currency {
        font-size: 13px;
    }

    .business-modal__asset {
        padding-bottom: 10px;
    }

    .create-withdrawal-request-modal__address-book {
        margin-left: 10px;
    }

    .create-withdrawal-request-modal__title-end {
        font-size: 13px;
    }

    .first-line, .second-line {
        font-size: 13px;
    }
}
::v-deep {
    .main-modal-wrapper {
        max-height: 100vh;
        .main-modal-body {
            overflow-x: hidden;
            overflow-y: auto;
            min-height: 220px;
        }
    }
}
.amount-max-input__label {
    font-family: $Gilroy;
    font-size: 13px;
    color: var(--new-front-input-label-font-color) !important;
}
</style>
